import React, { useState,useEffect } from 'react'
import Footer from '../inc/Footer'
import axios from "axios";
import "../inc/GlobalVars";
import Loader from '../inc/Loader';
import WinsList from '../inc/WinsList';

function YourWins() {
  const [biddingListItems, setBiddingListItems] = useState([]);
  const[loading,setLoading] = useState(false);
  const user_id = localStorage.getItem('userId');
 async function getBiddingList() {
  setLoading(true);
    try {
      const resp = await axios.post(global.apiUrl + "/getUserWinnings",JSON.stringify({user_id:user_id})).then(function (response) {
        const biddingData = response.data["data"];
      
        setBiddingListItems(biddingData);
        setLoading(false);
      }); 
    }
    catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    getBiddingList();
  }, []);

  const updateBids = () => {
    getBiddingList(); 
  };
  return (
    <div>
      {loading ? ( <Loader /> ) : (
            <>
      <div className='container'>
            <div className='row'>
            <div className="col-md-12 mb-3 mt-5">
            <h1>Your Wins</h1>
            </div>
            <div className='col-md-12 d-flex justify-content-center'>
              <div className='col-md-10'>
              {
              biddingListItems.length > 0 ? (
              biddingListItems.map((ac, key) => (
            <WinsList key={key} make_name={ac.make_name} manage_status={ac.manage_status} status_remarks={ac.status_remarks} updateBids={updateBids}
            model={ac.model} fuel_type={ac.fuel_type} expiry_date={ac.expiry_date} bid_time={ac.bid_time} vehicle_id={ac.vehicle_id} location={ac.location} rc_availability={ac.rc_availability} 
            reg_number={ac.reg_number} featured_image={ac.featured_image} bid_amount={ac.bid_amount} bid_status={ac.bid_status} variant = {ac.variant}
                year={ac.manufacture_year}
                transmission = {ac.transmission}
                cname = {ac.name}
                cmobile = {ac.mobile}
                bid_max_amount = {ac.bid_amount_max}
                bid_win_status = {ac.bid_win_status}
                can_bid = {ac.can_bid} />
            ))
            ) : (
              <h2>You Have No Wins</h2>
            )
                }
              </div>
            </div>
            </div>
        </div>
        
    
        <Footer />

        
</> )}</div> );
}

export default YourWins